package co.maytes.standupbot.dashboard.components.motion

import kotlinx.browser.document
import kotlinx.browser.window
import org.w3c.dom.Element
import org.w3c.dom.HTMLElement
import org.w3c.dom.asList

private const val GHOST_CLASS = "sb-ghost-out"
private const val GHOST_GRACE_MS = 80

object ExitGhost {
    fun play(source: HTMLElement, durationMs: Int) {
        val ghost = source.cloneNode(true) as HTMLElement
        ghost.removeAttribute("id")
        ghost.querySelectorAll("[id]").asList().forEach { (it as Element).removeAttribute("id") }
        ghost.setAttribute("aria-hidden", "true")
        ghost.setAttribute("inert", "")
        ghost.classList.add(GHOST_CLASS)
        document.body?.appendChild(ghost)
        window.setTimeout({ ghost.remove() }, durationMs + GHOST_GRACE_MS)
    }
}
